import PropTypes from 'prop-types';
import React from 'react';
import {
  Button,
  ButtonToolbar,
  ButtonGroup,
} from 'react-bootstrap';
import { Link } from 'react-router';

class TravelManagerHome extends React.Component {

  render() {
    return (
      <div className="container-fluid">
        <div className="row landing-center">
          <div className="col-sm-12">
            <h1>Welcome to Catch!</h1>
          </div>
          <hr />
          <div className="col-sm-12 landing-buttons">
              <Link to="/agency">
                <Button className="btn btn-lg btn-success">
                  Invite more team members
                </Button>
              </Link>
              <Link to="/tours">
                <Button className="btn btn-lg btn-success">
                  Create Group Travel
                </Button>
              </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default TravelManagerHome;



// WEBPACK FOOTER //
// src/routes/home/components/TravelManagerHome.js